import React from 'react'
import Link from 'gatsby-link'
import { Button, Form } from 'semantic-ui-react'

const Signupform = () => (
  <div
    style={{
      textAlign: 'center',
      display: 'inlineBlock',
    }}
  >
    
    <Form
      name="newslettersignupForm"
      // netlify-honeypot="bot-field"
      action="/thanks"
      // netlify
      size="large"
      method="post"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      style={{
        display: 'inline-block',
      }}
    >
    <input type="hidden" name="form-name" value="newslettersignupForm" />
      <Form.Group>
        <Form.Field>
          <Form.Input type="email" placeholder="Email" name="email" />
        </Form.Field>
        <Button primary type="submit">Subscribe</Button>
      </Form.Group>

      <p
        style={{
          display: 'none',
        }}
      >
        <input name="bot-field" />
      </p>
      <p>The latest growth tools straight to your inbox.</p>

    </Form>
    
  </div>
)

export default Signupform



// WEBPACK FOOTER //
// ./src/components/signupform.js